"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reverb_cookie_1 = require("./reverb_cookie");
function csrfToken() {
    return reverb_cookie_1.default.get('csrf_token');
}
exports.csrfToken = csrfToken;
function createOrUpdateTag(name, content) {
    var tag = $("meta[name=" + name + "]");
    if (tag.length) {
        tag.attr('content', content);
    }
    else {
        $('<meta>')
            .attr('name', name)
            .attr('content', content)
            .appendTo('head');
    }
}
function setMetaTags() {
    createOrUpdateTag('csrf-param', 'authenticity_token');
    createOrUpdateTag('csrf-token', csrfToken());
}
if (window.document) {
    $(document).ready(setMetaTags);
}
exports.default = {
    setMetaTags: setMetaTags,
    csrfToken: csrfToken,
};
//# sourceMappingURL=set_ajax_meta_tags.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/set_ajax_meta_tags.js
// module id = gw/t
// module chunks = 20 21